// Шкала свежести выдачи и чтение процентов из записи рейтинга. Вынесено отдельно, потому что
// одни и те же правила нужны и фильтру (RatingSidebar), и колонке таблицы (RatingItem).

// Бэкенд хранит доли работ не старше 1…6 месяцев — { m1, …, m6 }. Глубже шести не идём:
// последнее деление читается как «6 месяцев и глубже».
export const FRESHNESS_MONTHS = 6;

// Шаг ползунка процента. Единицы процента на выборке в ~100 работ ничего не различают,
// а ползунок с сотней делений мышью не поймать.
export const FRESH_PERCENT_STEP = 5;

// avgCreationDate — JSON { m1…m6 } с процентами. null означает «свежесть неизвестна»:
// так у записей, спарсенных до появления imageIds, и у тех, где ни у одной работы не оказалось
// даты заливки. Это НЕ то же самое, что «свежих работ нет» — в таблице рисуется прочерком.
export const freshShare = (avgCreationDate, months) => {
  const value = avgCreationDate?.[`m${months}`];

  return typeof value === 'number' ? value : null;
};

// Проценты в таблице — целыми: десятая доля процента ничего не решает, а строка короче.
export const formatFreshShare = (value) => (value === null ? '—' : `${Math.round(value)}%`);

// Подпись месяца на ползунке. Последнее деление — «6m+», потому что более глубоких порогов
// в записи просто нет: выбрав его, пользователь смотрит на самый широкий доступный срез.
export const formatMonths = (months) => (
  Number(months) >= FRESHNESS_MONTHS ? `${FRESHNESS_MONTHS}m+` : `${months}m`
);
